<template>
  <div id="ChangeStatusOrder">
    <el-row>
      <el-col :sm="6" :md="12" :lg="8">
        <Title
          title="Cambiar estado de ordenes"
          subtitle="Busca las ordenes por ruta, SOC o LPN y cambia su estado.">
        </Title>
      </el-col>
      <el-col v-if="activeFlow === 'status'" :sm="24" :md="12" :lg="12">

        <el-steps :active="active" align-center finish-status="success" class="stepsMaxWidth">
          <el-step v-for="(step, index) in steps" :title="step" :key="index">
          </el-step>
        </el-steps>

      </el-col>
    </el-row>

    <div class="content">
      <el-row>
        <el-tabs v-model="activeFlow" class="statusTabs">
          <el-tab-pane label="Cambio de estado de orden" name="status">
            <div class="stepContainerStyle">
              <FindRoute
                ref="findRouteComponent"
                v-if="active === 0"
                @routeFound="routeFound"
                @routeNotFound="routeNotFound" />
              <Route
                v-if="active === 1"
                :route-id="this.route.id"
                :enterprise-name="this.route.enterprise_name"
                :driver-name="this.route.driver_name"
                :plate="this.route.plate"
                :orders="this.route.orders"
                :reasons="this.reasons"
                :validation-warnings="this.route.validation_warnings"
                @ordersSent="ordersSent"
                @back="backstep" />
              <Report v-if="active === 2" :result="this.result" />
            </div>
          </el-tab-pane>
          <el-tab-pane label="Regularización de órdenes" name="regularization">
            <div class="stepContainerStyle">
              <RegularizeOrders />
            </div>
          </el-tab-pane>
        </el-tabs>
      </el-row>
    </div>
  </div>
</template>

<script>
import { apiRequest } from '@/backend/vue-axios/axios';
import Title from '../components/base/Title.vue';
import FindRoute from '../components/changeStatusOrder/findRoute.vue';
import Route from '../components/changeStatusOrder/route.vue';
import Report from '../components/changeStatusOrder/report.vue';
import RegularizeOrders from '../components/changeStatusOrder/RegularizeOrders.vue';


export default {
  name: 'ChangeStatusOrder',
  components: {
    Title,
    FindRoute,
    Route,
    Report,
    RegularizeOrders,
  },
  props: {
    value: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      steps: ['Buscar Ruta', 'Selección de estados', 'Reporte'],
      active: 0,
      route: {},
      result: [],
      reasons: [],
      activeFlow: 'status',
    };
  },
  mounted() {
    apiRequest(
      {
        module: 'location',
        service: 'reasons',
      },
    ).then((response) => {
      this.reasons = response.data;
    }).catch((error) => {
      this.$notify({
        type: 'info',
        title: 'Información',
        message: error.response.data.message,
      });

      this.$refs.inputFindRoute.focus();
    });
  },
  methods: {
    routeFound(route) {
      this.active += 1;
      this.route = route;

      this.$message({
        type: 'sucess',
        title: 'Información',
        message: 'Ruta encontrada.',
        duration: 5000,
        showClose: true,
      });
    },
    ordersSent(result) {
      this.active += 1;
      this.result = result;
    },
    backstep() {
      this.active -= 1;
    },
    routeNotFound(msg) {
      this.$message({
        type: 'warning',
        title: 'Advertencia',
        message: msg,
        duration: 5000,
        showClose: true,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.right {
  float: right;
}

.mt-1 {
  margin-top: 1rem;
}

.stepContainerStyle {
  //max-height: 500px;
  //overflow: scroll;
  width: 90%;
  border: 1px solid #E0E0E0;
  margin-top: 5px;
  padding: 1em;
  box-sizing: border-box;
}

.statusTabs {
  width: 90%;
}

.statusTabs .stepContainerStyle {
  width: 100%;
}
</style>
